import React, { Component } from 'react'; //different
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import { isMobile } from 'react-device-detect';
import NavMenu from './navmenu';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
import { t } from './i18n';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            tabselect: 1,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }


    checktab(e, index) {
        //console.log(index == 2 &&  this.state.qrcode != null);
        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else {
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselect: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselect: index,
                    tabselectsec: 0,
                });
            }
        }
    }
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };

    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }

    confirmdeposit = async (e, num) => {
        console.log(493, num)
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (token != null) {
            //   await instance.post("/api/v1/getredeempromotion", {
            //     userid: Username,
            //     System: Systems,
            //   }, {
            //     headers: { Authorization: `Bearer ${token}` }
            //   }).then(async (res) => {
            //     if (res.data.status === 200) {
            //       this.setState({
            //         proderedeem: res.data.message.tblpromotionredeems,
            //       });

            //     }
            //   }).catch(async (err) => {
            //   });
        }

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            console.log(res.data.picture)
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture,
                                counter: 300,
                                tabselectsec: 1,
                                tabselect: 0
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'mr_topup_min') + ' ' + this.state.limit.min + ' ' + t(this.lang, 'mr_baht_max') + ' ' + this.state.limit.max + ' ',
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok')
                })
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
            //deposittruemoneyModal
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            //////console.log(decoded);
            this.setState({
                userid: decoded.message.playerid,
                username: decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'ap_session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    async componentDidMount() {
        // this.checklogin();
        setInterval(() =>
            this.setState({
                counter: this.state.counter - 1
            })
            , 1000);
        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({
                    loginstate: false,
                });
            }
            if (token != null) {
                var decoded = jwt_decode(token);
                let Username = decoded.message.playerid;
                instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    amount: 50
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    //////console.log(res.data.picture)
                    this.setState({
                        mainacc: res.data.mainacc,
                    });
                });
            }
        }
        catch (error) {
            //////console.log();
        }
        try {

            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    // console.log( datas[7].value)
                    var min = res.data.tblcatagoryx[0].limitdeposit;
                    var max = res.data.tblcatagoryx[0].maxdeposit;
                    var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
                    var limit = { min, max }
                    this.setState({
                        maxwithdrawstatus: maxwithdrawstatus,
                        linelink: datas[1].value,
                        webnamex: datas[7].value,
                        System: res.data.tblcatagoryx[0].System,
                        cashoutSet: res.data.tblcashoutsetting[0],
                        inviteSet: res.data.tblinvitedsetting[0],
                        datas: datas,
                        limit: limit,
                    });
                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (ex) {
            console.log(ex);
        }
    }
    render() {
        const pathname = this.state.pathname
        const { loginstate, userid, username, point, accnumber, firstname, rankpoint, mainacc, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        return (
            <>
                <div className="-games-index-page col-12">
                    <div className="mb-2 text-white-v1">
                        <div className="d-none d-lg-block">
                            <div>
                                <br />
                                <br />
                                <br />
                            </div>
                            {/**/}
                            {/**/}
                            <div>{/**/}</div>
                            {/**/}
                            {/**/}
                        </div>
                        {/**/}
                        <div className="padding-router-view">
                            <div className="container p-0 x-margin-top-v3">
                                <div className="row m-0 border-shadow-title">
                                    <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                        <div className="text-center bg-title-web">
                                            <div>
                                                <div className="text-title text-white-v1 text-center">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="text-white-v1-deposit" href='/'>
                                                            <a role="button">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={25}
                                                                    height={25}
                                                                    fill="currentColor"
                                                                    className="bi bi-arrow-left-circle text-color-back"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                    />
                                                                </svg>
                                                            </a>
                                                        </div>
                                                        <div className="text-white-v1-deposit">
                                                            <h5>{t(this.lang, 'ap_account_info')}</h5>
                                                        </div>
                                                        <div>{/**/}</div>
                                                    </div>
                                                    <hr className="mt-0" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="js-profile-account-modal -layout-account">
                                            <div className="x-account-profile -v2">
                                                <div
                                                    data-animatable="fadeInModal"
                                                    className="-profile-container animated fadeInModal"
                                                >
                                                    <div className="bg-profile-box">
                                                        <div className="d-flex justify-content-start align-self-center bg-dark-table p-2">
                                                            <div>
                                                                <div className="d-flex justify-content-start">
                                                                    <div className="align-self-center">
                                                                        <img
                                                                            width={"100px"}
                                                                            className="img-fluid -profile-image"
                                                                            src={"/build/rank/" + this.state.rankpic}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="p-2 align-self-center">
                                                                        <div className="username-profile">
                                                                            <b>
                                                                                {username}
                                                                            </b>
                                                                        </div>
                                                                        <div className="username-profile">
                                                                            <span className="badge text-bg-light">
                                                                                Bronze
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="x-admin-contact text-center m-0">
                                                            <a
                                                                role="button"
                                                                className="-link-change-password"
                                                                data-toggle="collapse"
                                                                data-target=".js-change-password-collapse"
                                                            >
                                                                <u>{t(this.lang, 'ap_change_password')}</u>
                                                            </a>
                                                            <br />
                                                            <span className="x-text-with-link-component">
                                                                <label className="-text-message">{t(this.lang, 'ap_found_problem')}</label>
                                                                <a
                                                                    role="button"
                                                                    href= {this.state.linelink}
                                                                    className="-link-message"
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                >
                                                                    <u>{t(this.lang, 'ap_contact_support')}</u>
                                                                </a>
                                                            </span>
                                                        </div>
                                                        <div className="animated animatedFadeInUp fadeInUp bg-profile-box-overview mb-2">
                                                            <div>
                                                                <div className="text-white-v1 text-center mx-auto my-auto">
                                                                    <div className="p-1 p-sm-1">
                                                                        <div className="flex justify-between mb-1 mx-auto">
                                                                            <div className="sub-content w-100 p-3 credit-bl-text">
                                                                                <div className="text-center">
                                                                                    <img
                                                                                        className="rounded-full w-10 mb-2 flex"
                                                                                        src={accnumber !== null ? accnumberx.img_path : ""}
                                                                                        style={{ width: 38 }}
                                                                                    />{" "}
                                                                                    &nbsp; {accnumber !== null ? accnumberx.fullname_th : ""}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                    {firstname} &nbsp; | &nbsp;  {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                        <div className="pt-2 pb-2">
                                                            <div className="bg-profile-box-overview p-2 mb-2">
                                                                <div className="text-right">
                                                                    <small id="max_deposit">0 %</small>
                                                                </div>
                                                                <div className="pb-0">
                                                                    <div
                                                                        className="progress progress-lv"
                                                                        role="progressbar"
                                                                        aria-label="Example with label"
                                                                        aria-valuenow={0.0}
                                                                        style={{ height: "5px !important" }}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={3000}
                                                                    >
                                                                        <div
                                                                            className="progress-bar"
                                                                            style={{ width: "0%" }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="align-self-center text-left pt-2">
                                                                        <div role="button">
                                                                            <small className="font-play-text">
                                                                                {t(this.lang, 'current_deposit')}
                                                                            </small>
                                                                            <div>
                                                                                <b>0.00 {t(this.lang, 'ap_baht')}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right pt-2">
                                                                        <div role="button">
                                                                            <small className="font-play-text">
                                                                                {t(this.lang, 'need_deposit')}
                                                                            </small>
                                                                            <div>
                                                                                <b>3,000.00 {t(this.lang, 'ap_baht')}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr className="m-0 color-hr" />
                                                            </div>
                                                            <table className="table bg-dark-table">
                                                                {this.state.tblrankall.map((listitem, i) => (
                                                                    <tr key={i} id={listitem.no} style={{color:"white"}}>
                                                                        <td className="-description-body-wrapper">
                                                                            <img
                                                                                width={"100px"}
                                                                                className="img-fluid -profile-image"
                                                                                src={"/build/rank/" + listitem.image}
                                                                                alt=""
                                                                            />
                                                                            <div className="-title-wrapper">
                                                                                <p><span className="-title">{listitem.name}</span>        </p>
                                                                            </div>
                                                                            <div className="-state-wrapper">
                                                                                <span className="-text-description">{t(this.lang, 'ap2_topup_word') + " " +  Number(listitem.lowamount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(this.lang, 'deposit_baht_up')} {(listitem.no === 1) ? "" : t(this.lang, 'ap2_bonus_word') + Number(listitem.claimamount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " " + t(this.lang, 'ap_baht')} </span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="-transaction-body-wrapper">
                                                                            {
                                                                                (listitem.no === 1) ? "" :
                                                                                    (Number(listitem.lowamount) <= rankpoint && !listitem.checked) ? <div> <img
                                                                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                                        className="-ic"
                                                                                        width={"30px"}
                                                                                        alt=""
                                                                                    /><span className="-state-title" style={{ marginLeft: "10px" }}>{t(this.lang, 'ap_success')}</span></div> :
                                                                                        (!listitem.checked) ? t(this.lang, 'not_qualified') : <a href={() => false} style={{ cursor: "pointer" }} className="text-white js-account-approve-aware btn -btn-deposit active" onClick={(e) => {
                                                                                            this.redeemrank(e, listitem)
                                                                                        }}><div className="f-7">Cliam</div></a>}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                {/* <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="text_aff_affiliate text-center text-bg-color">
                                                                            <small>ลำดับ Level</small>
                                                                        </td>
                                                                        <td className="text_aff_affiliate text-center text-bg-color">
                                                                            <small>ยอดฝากสะสมขั้นต่ำ</small>
                                                                        </td>
                                                                        <td className="text_aff_affiliate text-center text-bg-color">
                                                                            <small>คืนยอดเสียสูงสุด</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5333b3c7-890a-4864-2621-5c683388b500/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Bronze</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            0
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            0
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4818e46f-2e91-45ce-9297-1b96f4e05e00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Silver</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            3,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            500
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/80a99bfb-71dd-4ebd-1949-939756a1ad00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Silver +</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            10,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            1,000
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/7dae2b09-b91d-46b2-8ee7-dd02d037d000/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Gold</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            50,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            1,500
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/61af04ae-e0b4-4fe5-63ef-8ab2c4207800/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Gold +</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            100,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            2,000
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6293a1a7-1e88-4fba-6319-73dd737d2200/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Diamond</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            500,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            2,500
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9a186e88-3a5c-40ef-6acf-81c9df653500/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Diamond +</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            1,000,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            3,000
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4cccf08-624e-4162-5097-7ca3b329bc00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Platinum</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            5,000,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            3,500
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/1f0f9752-5996-402b-c7c9-ff8ea428ef00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Platinum +</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            10,000,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            4,000
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/58bb18f6-22c0-4a13-8e63-fa5560f16f00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Black</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            50,000,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            4,500
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="text-center border-member_level pb-2">
                                                                        <td
                                                                            className="text-left p-1-aff text_aff_affiliate text-left"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            <div className="text_aff_affiliate">
                                                                                <img
                                                                                    className="logo-profile-user-list"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/b0cd301e-79ee-4b69-88de-4a1cfd0e2c00/public"
                                                                                    alt=""
                                                                                />
                                                                                <small className="p-2">Black +</small>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            100,000,000
                                                                        </td>
                                                                        <td
                                                                            className="credit-bl-text text_aff_affiliate text-center text-white-v1"
                                                                            style={{ verticalAlign: "middle" }}
                                                                        >
                                                                            5,000
                                                                        </td>
                                                                    </tr>
                                                                </tbody> */}
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
export default App;
